/**
 * lazy-load teaserbox images
 */
window.addEventListener("load", function() {
    var lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    let active = false;

    const lazyLoad = function() {
        if (active === false) {
            active = true;

            setTimeout(function() {
                lazyImages.forEach(function(lazyImage) {
                    if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0)) {
                        lazyImage.src = lazyImage.dataset.src;
                        lazyImage.srcset = lazyImage.dataset.srcset;
                        lazyImage.classList.remove("lazy");

                        lazyImages = lazyImages.filter(function(image) {
                            return image !== lazyImage;
                        });

                        if (lazyImages.length === 0) {
                            document.removeEventListener("scroll", lazyLoad);
                            window.removeEventListener("resize", lazyLoad);
                            window.removeEventListener("orientationchange", lazyLoad);
                        }
                    }
                });

                active = false;
            }, 200);
        }
    };
    lazyLoad();

    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
});

/**
 * lazy-load slideshow slides
 */
window.addEventListener("load", function() {
    var lazyImages = [].slice.call(document.querySelectorAll(".lazy-slide"));
    let active = false;

    const lazyLoadBg = function() {
        if (active === false) {
            active = true;

            setTimeout(function() {
                lazyImages.forEach(function(lazyImage) {
                    if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0)) {
                        lazyImage.style.backgroundImage = "url('"+lazyImage.dataset.src+"')";
                        lazyImage.classList.remove("lazy-slide");
                        lazyImages = lazyImages.filter(function(image) {
                            return image !== lazyImage;
                        });

                        if (lazyImages.length === 0) {
                            document.removeEventListener("scroll", lazyLoadBg);
                            window.removeEventListener("resize", lazyLoadBg);
                            window.removeEventListener("orientationchange", lazyLoadBg);
                        }
                    }
                });

                active = false;
            }, 200);
        }
    };

    lazyLoadBg();
});
